import { DeleteOutlined, EditOutlined, PlusOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, ConfigProvider, Input, Pagination, Select, Switch, Table, TableColumnsType } from 'antd';
import viVN from 'antd/locale/vi_VN';
import React, { useEffect, useMemo, useState } from 'react';
import Layout from '../../../Layout';
import * as SelectOptionApi from '../../../api/selectOptions/selectOptionsApi';
import * as DepartmentalUnitApi from '../../../api/unit/departmentalUnitApi';
import * as UnitApi from '../../../api/unit/unitApi';
import ModalDeleteManager from '../../../components/ModalDeleteManager';
import useToast from '../../../hook/useToast';
import { checkDisabledPermission, dataPagination, findParentIdLevelOne, flattenDonViArray, fommatSelectOption, getUserPermissions } from '../../../until';
import ModalCreateDepartment from './Modal/ModalCreateDepartment';
import ModalEditDepartment from './Modal/ModalEditDepartment';
import ModalManagerMajor from './Modal/ModalManangeMajor';
import useLoading from '../../../hook/useLoading';
import DrawerAddvance from '../../VehicleManagement/VehicleList/Component/Drawer/DrawerAddvance';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { NodataTable } from '../../../components/NoDataTable';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { formatNumber } from '../../../services/mixin';

const Departments: React.FC = () => {
  const pushLoading = useLoading()
  const pushToast = useToast();
  const location = useLocation();
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, } = getUserPermissions(permissionSlice, location.pathname)

  const [openCreateDepartment, setOpenCreateDepartment] = useState(false)
  const [openEditDepartment, setOpenEditDepartment] = useState(false)
  const [openManageMajor, setOpenManageMajor] = useState(false)
  const [openDeleteDepartment, setOpenDeleteDepartment] = useState(false)
  const [isOpenAddvance, setIsOpenAddvance] = useState(false);

  const [dataDepartmentalUnit, setDataDepartmentalUnit] = useState<DepartmentalUnitApi.DataTypeDepartmentalUnit[]>([])
  const [dataConvert, setDataConvert] = useState<SelectOptionApi.dataConvert[]>([])
  const [dataBusinessUnit, setDataBusinessUnit] = useState<SelectOptionApi.ISelectOption[]>([])
  const [dataListBusinessUnit, setDataListBusinessUnit] = useState<SelectOptionApi.IBusinessUnit[]>([])
  const [dataListNationwide, setDataListNationwide] = useState<any>()
  const [dataListNationwideCreate, setDataListNationwideCreate] = useState<any>()

  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });


  const [id, setId] = useState<number>()
  const [search, setSearch] = useState<string>()
  const [valueBusinessUnit, setValueBusinessUnit] = useState<number[]>()
  const [sLBusinessUnit, setSLBusinessUnit] = useState<SelectOptionApi.IBusinessUnit[]>([])

  const defaultColumnsShow = [
    'action', 'codeDepartment', 'nameDepartment', 'businessUnitTitle', 'nationwide', 'unit', 'agentTitle', 'region', "status"
  ] as any;
  let columnDefs = useMemo<ColDef<any>[]>(() =>
    [
      {
        headerName: 'Hành động',
        field: 'action',
        colId: 'action',
        width: 180,
        resizable: false,
        suppressMovable: true,
        lockPosition: 'left',
        headerComponentParams: {
          template: '<span class="w-full flex items-center justify-center">Hành động</span>'
        },
        cellRenderer: (params: ICellRendererParams) => {
          const { key } = params.data;
          return (
            <div className='h-full d-flex align-center justify-center gap-10-px'>
              <EditOutlined
                className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer   ${checkDisabledPermission(edit)}`}
                onClick={() => { setOpenEditDepartment(true); setId(Number(key)) }}
              />
              <DeleteOutlined
                className={`text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded-2 cursor-pointer   ${checkDisabledPermission(isdelete)}`}
                onClick={() => { setOpenDeleteDepartment(true); setId(Number(key)) }}
              />

            </div>
          );
        }
      },
      {
        headerName: 'Mã phòng ban',
        field: 'codeDepartment',
        colId: 'codeDepartment',
        flex: 1,
        minWidth: 140,
        sortable: true,
        comparator: (valueA: string, valueB: string) => valueA.length - valueB.length
      },
      {
        headerName: 'Tên phòng ban',
        field: 'nameDepartment',
        colId: 'nameDepartment',
        flex: 1,
        minWidth: 168,
        sortable: true,
        comparator: (valueA: string, valueB: string) => valueA.length - valueB.length
      },
      {
        headerName: 'Khối/nghiệp vụ',
        field: 'businessUnitTitle',
        colId: 'businessUnitTitle',
        flex: 1,
        minWidth: 170
      },
      {
        headerName: 'Toàn quốc',
        field: 'nationwideTitle',
        colId: 'nationwideTitle',
        flex: 1,
        minWidth: 156,
        sortable: true,
        valueGetter: (params) => {
          return params.data.nationwideTitle || findParentIdLevelOne(dataConvert, params.data.parentId, 1);
        },
        comparator: (valueA: string, valueB: string) => valueA.localeCompare(valueB)
      },
      {
        headerName: 'Đơn vị',
        field: 'unitTitle',
        colId: 'unitTitle',
        flex: 1,
        minWidth: 175,
        sortable: true,
        valueGetter: (params) => {
          return params.data.unitTitle || findParentIdLevelOne(dataConvert, params.data.parentId, 4);
        },
        comparator: (valueA: string, valueB: string) => valueA.localeCompare(valueB)
      },
      {
        headerName: 'Showroom/Điểm xưởng',
        field: 'agentTitle',
        colId: 'agentTitle',
        flex: 1,
        minWidth: 175,
        sortable: true,
        // valueGetter: (params) => {
        //   return params.data.unitTitle || findParentIdLevelOne(dataConvert, params.data.parentId, 4);
        // },
        // comparator: (valueA: string, valueB: string) => valueA.localeCompare(valueB)
      },
      {
        headerName: 'Vùng miền',
        field: 'regionTitle',
        colId: 'regionTitle',
        flex: 1,
        minWidth: 125,
        sortable: true,
        valueGetter: (params) => {
          return params.data.regionTitle || findParentIdLevelOne(dataConvert, params.data.parentId, 2);
        },
        comparator: (valueA: string, valueB: string) => valueA.localeCompare(valueB)
      },
      {
        headerName: 'Trạng thái',
        field: 'status',
        colId: 'status',
        flex: 1,
        minWidth: 175,
        cellRenderer: (params: ICellRendererParams) => {
          const { key, view } = params.data;
          return (
            <div className='d-flex align-center gap-10-px'>
              <Switch
                defaultChecked={!!view}
                onChange={() => updateActiveDepartmentalUnit(Number(key))}
                className={`rs-switch rs-switch--sm   ${checkDisabledPermission(edit)}`}
              />
              <p className='font-medium fw-500 text-344054'>{UnitApi.activeArray[view ? 1 : 0]}</p>
            </div>
          );
        }
      }
    ], [pagination]);

  const gSLUnit = async () => {
    const result = await SelectOptionApi.getListBusinessUnit();
    if (result?.status) {
      setSLBusinessUnit(result.data);
    } else {
      pushToast(result.message, "error", 2000)

    }
  }

  const getListBusinessUnit = async () => {
    const result = await SelectOptionApi.getListBusinessUnit();
    if (result?.status) {
      setDataBusinessUnit(convertDataBusinessUnit(result.data));
      setDataListBusinessUnit(result.data);
    } else {
      pushToast(result?.message, "error", 2000)

    }
  }
  const convertDataBusinessUnit = (data: SelectOptionApi.IBusinessUnit[]) => {
    const convertData = data.map((item) => ({
      value: item.id,
      label: item.title
    }))
    return convertData
  }

  const getListDepartmentalUnit = async (pageCurent: number = 1, pageSize: number = 10) => {
    pushLoading(true)
    const result = await DepartmentalUnitApi.getListDepartmentalUnit(pageSize, pageCurent, search, valueBusinessUnit);
    if (result?.status) {

      setDataDepartmentalUnit(convertData(result.data))
      setPagination({ current: pageCurent, total: result.total, pageSize })
    } else {
      pushToast(result?.message, "error", 2000)
    }
    pushLoading(false)
  }
  const convertData = (data: DepartmentalUnitApi.IDepartmentalUnit[]) => {
    const convertData = data.map((item) => ({
      codeDepartment: item.code,
      nameDepartment: item.title,
      businessUnitTitle: item.businessUnitTitle,
      nationwide: '',
      unit: '',
      region: '',
      key: item.id,
      parentId: item.parentId,
      view: item.view,
      unitTitle: item?.unitTitle,
      provinceTitle: item?.provinceTitle,
      agentTitle: item?.agentTitle,
      regionTitle: item?.regionTitle,
      nationwideTitle: item?.nationwideTitle
    }
    ))
    return convertData
  }



  function convertNationwide(data: UnitApi.OptionSelect[], id: number) {
    return data.filter((value) => value.value !== id).map((item) => {
      const treeItem: UnitApi.OptionSelect = {
        value: item.value,
        label: `${item.label}`,
        title: item.title,
        children: []
      };
      if (item.children != null && item.children.length > 0) {
        treeItem.children = convertNationwide(item.children, id);
      }
      return treeItem;
    });
  }

  const gListNationwide = async () => {
    const result = await DepartmentalUnitApi.getListNationwide();
    if (result?.status) {
      setDataConvert(flattenDonViArray(result.data))
      setDataListNationwide(UnitApi.convertNationwideValueToTree(result.data))
      setDataListNationwideCreate(UnitApi.convertNationwideValueToTree(result.data))
    } else {
      pushToast(result?.message, "error", 2000)

    }
  }

  // thay đổi trang thái
  const updateActiveDepartmentalUnit = async (id: number) => {
    const result = await DepartmentalUnitApi.updateActiveDepartmentalUnit(id);
    if (result?.status) {
      getListDepartmentalUnit(pagination.current, pagination.pageSize)
      pushToast(result.message, "success", 2000)
    } else {
      pushToast(result.message, "error", 2000)
    }
  }

  const onSubmitFormModalAdd = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setOpenCreateDepartment(false)
      pushToast(message, "success")
      getListDepartmentalUnit(pagination.current, pagination.pageSize)
    } else {
      pushToast(message, "error")
    }
  }

  const onSubmitFormModalEdit = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setOpenEditDepartment(false)
      pushToast(message, "success")
      getListDepartmentalUnit(pagination.current, pagination.pageSize)
    } else {
      pushToast(message, "error")
    }
  }

  const handleDelete = async () => {
    if (id) {
      const result = await DepartmentalUnitApi.deleteDepartments(id);
      if (result?.status) {
        getListDepartmentalUnit(pagination.current, pagination.pageSize)
        setOpenDeleteDepartment(false)
        pushToast("Xóa đơn vị thành công!", "success", 2000)

      } else {
        pushToast(result.message, "error", 2000)
      }
    }
  }
  const onPaginationChange = (current: number, pageSize: number) => {
    setPagination((prev) => ({ ...prev, current: current, pageSize }))
    getListDepartmentalUnit(current, pageSize)
  }

  const checkedList = localStorage.getItem('departmentsColums')
    ? JSON.parse(localStorage.getItem('departmentsColums') as string)
    : [...defaultColumnsShow];

  // Sử dụng colId thay vì key
  const columnDefsWithVisibility = useMemo(() => {
    return columnDefs.map((item: any) => ({
      ...item,
      hide: !checkedList.includes(item.colId) // Sử dụng hide property của AG Grid
    }));
  }, [columnDefs, checkedList]);

  const handleCloseSetting = (value: any, isChange: boolean, reorderedColumns: any[]) => {
    if (isChange) {
      localStorage.setItem('departmentsColums', JSON.stringify(value));
      // Cập nhật trạng thái cột với các cột được sắp xếp lại, bảo toàn thuộc tính ẩn
      const updatedColumns = reorderedColumns.map((col) => ({
        ...col,
        hidden: !value.includes(col.colId),
      }));
      // setColumnDefs(updatedColumns);
      columnDefs = updatedColumns
    }
    setIsOpenAddvance(false);
  };
  useEffect(() => {
    document.title = 'THACO AUTO CRM';
    gListNationwide()
    getListBusinessUnit()
    gSLUnit()
  }, []);
  useEffect(() => {
    getListDepartmentalUnit()

  }, [search, valueBusinessUnit]);
  useEffect(() => {
    if (id) {
      setDataListNationwide(convertNationwide(dataListNationwideCreate, id))
    }
  }, [id, openEditDepartment]);
  return (
    <Layout>
      <ModalCreateDepartment
        dataBusinessUnit={dataBusinessUnit}
        dataListNationwide={dataListNationwideCreate}
        isOpen={openCreateDepartment}
        onSubmitFormModal={onSubmitFormModalAdd}
        closeModal={() => setOpenCreateDepartment(!openCreateDepartment)}
      />
      <ModalEditDepartment
        dataBusinessUnit={dataBusinessUnit}
        dataListNationwide={dataListNationwide}
        id={id}
        onSubmitFormModal={onSubmitFormModalEdit}
        isOpen={openEditDepartment}
        closeModal={() => setOpenEditDepartment(!openEditDepartment)}
      />
      <ModalManagerMajor
        isOpen={openManageMajor}
        getListBusinessUnit={getListBusinessUnit}
        dataListBusinessUnit={dataListBusinessUnit}
        closeModal={() => setOpenManageMajor(!openManageMajor)}
      />
      <ModalDeleteManager
        isOpen={openDeleteDepartment}
        onConfirm={handleDelete}
        closeModal={() => setOpenDeleteDepartment(!openDeleteDepartment)}
        title="Bạn có chắc chắn xóa phòng ban này"
        titleDelete="Xóa phòng ban"
        content="Phòng ban và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục"
      />
      <DrawerAddvance
        isOpen={isOpenAddvance}
        columns={columnDefs}
        defaultColumnsShow={defaultColumnsShow}
        localStorageValue="departmentsColums"
        onClose={(value, isChange, reorderedColumns) => handleCloseSetting(value, isChange, reorderedColumns)}
        closeDrawer={() => setIsOpenAddvance(!isOpenAddvance)}
      />
      <Breadcrumb
        items={[
          {
            title: 'THACO AUTO CRM',
          },
          {
            title: <a href="/">Danh mục đơn vị</a>,
          },
          {
            title: 'Phòng ban',
          },
        ]}
      />
      <div className='title-page'>
        Phòng ban
      </div>
      <div className='d-flex align-center gap-10-px pb-18-px '>
        <p className='text-base font-medium text-344054 white-space-nowrap'>Danh sách phòng ban</p>

        <div className="w-682-px border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3  py-1 h-8 justify-between overflow-hidden">
          <Input
            placeholder="Tìm kiếm "
            className="bg-FCFCFD text-sm border-none custom-input-focus none-focus-erro font-regular p-none-input place-holder-input-667085 hover-none"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className=" border-l-F2F4F7 h-full d-flex align-center">
            <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
          </div>
        </div>
        <Select
          allowClear
          mode='multiple'
          placeholder="Chọn khối nghiệp vụ"
          options={fommatSelectOption(sLBusinessUnit)}
          value={valueBusinessUnit}
          onChange={(e) => setValueBusinessUnit(e)}
          className="custom-select-mutiple-v2 w-300-px"

          popupMatchSelectWidth={false}

        />
        <button className='h-34-px white-space-nowrap d-flex justify-center align-center border-E1E1E1 text-4B4B4B bg-white rounded-2 text-sm font-regular gap-1'
          onClick={() => setOpenManageMajor(true)}
        >
          <PlusOutlined className='text-18-px text-4B4B4B' />
          Khối/nghiệp vụ
        </button>

        <Button
          type='primary'
          icon={<PlusOutlined />}
          className={`s-button rs-button--sm   ${checkDisabledPermission(add)}`}
          onClick={() => setOpenCreateDepartment(true)}
        >
          Tạo mới
        </Button>
        <button
          className="border-EAECF0 bg-white rounded-2 w-8 h-8 shadow-btn-save"
          onClick={() => setIsOpenAddvance(true)}
        >
          <SettingOutlined className="text-sm text-344054" />
        </button>
      </div>


      <div className={`order-history-card__body custom-page-css flex flex-col flex-1 justify-between`}>
        <div className="ag-theme-alpine custom-table-ag custom-css-table" style={{ width: '100%', height: 610 }}>
          <AgGridReact
            className="my-auto-height-grid"
            getRowStyle={(params: any) => ({
              backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
            })}
            rowData={dataDepartmentalUnit}
            rowHeight={55}
            columnDefs={columnDefsWithVisibility}
            rowSelection={{ mode: 'multiRow' }}
            // rowSelection="multiple"
            overlayNoRowsTemplate={NodataTable}
            suppressDragLeaveHidesColumns={true}
          />

        </div>
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination showSizeChanger current={pagination.current} pageSize={pagination.pageSize} total={pagination.total}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize,
                pagination.current).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationChange}
            />
          </div>
        </ConfigProvider>
      </div>
    </Layout>
  );
}

export default Departments;
